import { NgModule } from "@angular/core";
import { WeeklyCheckupPage } from "./weekly-checkup-page";
import { CsCoachCheckupReview } from "./cs-coach-checkup-review";
import { PagesModule } from 'pages/pages.module';
import { ComponentsModule } from 'components/components.module';
import { DirectivesModule } from "directives/directives.module";

@NgModule({
  declarations: [WeeklyCheckupPage, CsCoachCheckupReview],
  imports: [PagesModule, ComponentsModule, DirectivesModule],
  exports: [WeeklyCheckupPage]
})
export class WeeklyCheckupPageModule { }